<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>发票管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">发票管理</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="账号名称">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入账号名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态">
                  <el-select
                    v-model="ruleForm.status"
                    placeholder="请选择状态"
                    style="margin-right: auto"
                  >
                    <el-option label="待开票" value="0"></el-option>
                    <el-option label="已开票" value="1"></el-option>
                    <el-option label="已撤销" value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-button type="primary" @click="InvoicingAll()" class="btn"
          >批量开票</el-button
        >
        <el-button type="primary" @click="exportList()" class="btn"
          >excel导出</el-button
        >
        <TableScrollSlider :table-ref="$refs.multipleTable" />
        <el-table
          :data="tableData"
          style="width: 100%; margin-top: 20px"
          @selection-change="handleSelectionChange"
          tooltip-effect="dark"
          ref="multipleTable"
        >
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column label="发票金额" align="center">
            <template slot-scope="scope">
              {{ scope.row.amount | moneyFormat }}</template
            >
          </el-table-column>
          <el-table-column label="类型" align="center">
            <template slot-scope="scope">{{
              scope.row.invoiceType == 0 ? "对公" : "个人"
            }}</template>
          </el-table-column>
          <el-table-column
            label="公司名称"
            align="center"
            prop="name"
            width="150"
          >
          </el-table-column>
          <el-table-column label="是否保安公司" align="center">
            <template slot-scope="scope">{{
              scope.row.isGuardCompany == 0 ? "否" : "是"
            }}</template>
          </el-table-column>
          <el-table-column label="税号" align="center" prop="taxNo" width="180">
          </el-table-column>
          <el-table-column
            label="注册地址"
            align="center"
            prop="address"
            width="180"
          >
          </el-table-column>
          <el-table-column
            label="注册电话"
            align="center"
            prop="phone"
            width="150"
          >
          </el-table-column>
          <el-table-column
            label="开户行"
            align="center"
            prop="bankName"
            width="180"
          >
          </el-table-column>
          <el-table-column
            label="开户行银行号"
            align="center"
            prop="account"
            width="200"
          >
          </el-table-column>
          <el-table-column label="收件人" align="center" prop="consigneeName">
          </el-table-column>
          <el-table-column label="快递电话" align="center" width="150">
            <template slot-scope="scope">
              {{ scope.row.consigneePhone }}</template
            >
          </el-table-column>
          <el-table-column label="快递地址" align="center" width="180">
            <template slot-scope="scope">{{
              scope.row.consigneeAddress
            }}</template>
          </el-table-column>
          <el-table-column label="状态" align="center" width="100">
            <template slot-scope="scope">
              <span class="blueColor" v-if="scope.row.status == 0">待开票</span>
              <span class="greenColor" v-if="scope.row.status == 1"
                >已开票</span
              >
              <span class="redColor" v-if="scope.row.status == 2">被否决</span>
              <span class="redColor" v-if="scope.row.status == 3">已撤销</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="创建时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <div class="disAround">
                <div
                  class="operateBtn"
                  @click="Invoicing(scope.row)"
                  v-if="scope.row.status != 1"
                >
                  开票
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
import axios from "axios";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.financeData(),
      ruleForm: {
        name: "",
        status: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      multipleTable: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    exportList() {
      this.$confirm("是否导出数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.multipleTable.length == 0) {
            this.$message({
              message: "请选择导出数据",
              type: "warning",
            });
            return;
          }
          let arr = [];
          for (var i = 0; i < this.multipleTable.length; i++) {
            arr.push(this.multipleTable[i].id);
          }
          let param = {
            ids: arr,
          };
          this.$axios
            .post("/admapi/invoice/export", param, { responseType: "blob" })
            .then((data) => {
              console.log(data);
              let val = new Blob([data.data], {
                type: "application/vnd.ms-excel;charset=utf-8",
              });
              let header = decodeURI(data.headers["content-disposition"]);
              console.log(header);
              let index = header.indexOf("''");
              let fileName = header.substring(index + 2, header.length);
              const url = window.URL.createObjectURL(val);
              const link = document.createElement("a");
              link.download = fileName; // 设置a标签的下载属性
              link.style.display = "none";
              link.href = url;
              document.body.appendChild(link);
              link.click();
              URL.revokeObjectURL(link.href); // 下载完成释放URL 对象
              document.body.removeChild(link);
            })
            .catch()
            .finally();
          // );
        })
        .catch(() => {});
    },
    InvoicingAll() {
      this.$confirm("是否批量开票", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.multipleTable.length == 0) {
            this.$message({
              message: "请选择开票数据",
              type: "warning",
            });
            return;
          }
          let arr = [];
          for (var i = 0; i < this.multipleTable.length; i++) {
            arr.push(this.multipleTable[i].id);
          }
          let param = {
            idList: arr,
          };
          this.$axios
            .post(`/admapi/invoice/batchapply`, param)
            .then(({ data }) => {
              this.$message({
                message: "批量开票成功",
                type: "success",
              });
              this.multipleTable = [];
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    Invoicing(val) {
      this.$confirm("是否开票", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`/admapi/invoice/apply/${val.id}`, { id: val.id })
            .then(({ data }) => {
              this.$message({
                message: "开票成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleTable = val;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        queryParams: [
          { name: "name", type: "input", value: this.ruleForm.name },
        ],
      };
      if (this.ruleForm.status != "") {
        param.queryParams.push({
          name: "status",
          type: "select",
          values: [{ itemKey: this.ruleForm.status }],
        });
      }
      this.$axios
        .post(`/admapi/invoice/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped></style>
